import * as React from "react";

function SvgIcUserReject(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.97 2.47a.75.75 0 011.06 0l.97.97.97-.97a.75.75 0 111.06 1.06l-.97.97.97.97a.75.75 0 01-1.06 1.06L19 5.56l-.97.97a.75.75 0 11-1.06-1.06l.97-.97-.97-.97a.75.75 0 010-1.06zM12 5a2 2 0 100 4 2 2 0 000-4zM8 7a4 4 0 118 0 4 4 0 01-8 0zM12 14a5 5 0 00-5 5h10a5 5 0 00-5-5zm-7 5a7 7 0 1113.998.184c-.03 1.12-.99 1.816-1.927 1.816H6.929c-.937 0-1.898-.697-1.927-1.816A7.15 7.15 0 015 19z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgIcUserReject;
